module.exports = __webpack_public_path__ + "img/icon-sb-mattress-medium-40.4d465a5.svg";